import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=6ae93872&scoped=true"
import script from "./Competition.vue?vue&type=script&lang=js"
export * from "./Competition.vue?vue&type=script&lang=js"
import style0 from "./Competition.vue?vue&type=style&index=0&id=6ae93872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae93872",
  null
  
)

export default component.exports